<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12">
        <div class="card mt-2">
          <div class="card-header mb-0 d-flex justify-content-between align-items-center flex-wrap gap-2">
            <h5 class="mb-0">{{ $t("content.amnexportitemoverdue") }}</h5>
            <div class="d-flex gap-2">
              <material-button
                :color="viewMode === 'visual' ? 'primary' : 'secondary'"
                :variant="viewMode === 'visual' ? 'fill' : 'outline'"
                size="sm" class="m-0 text-nowrap"
                @click="setViewMode('visual')">
                <i class="material-icons material-symbols-outlined">insert_chart</i>
                รูปภาพ
              </material-button>
              <material-button
                :color="viewMode === 'table' ? 'primary' : 'secondary'"
                :variant="viewMode === 'table' ? 'fill' : 'outline'"
                size="sm" class="m-0 text-nowrap"
                @click="setViewMode('table')">
                <i class="material-icons material-symbols-outlined">table_rows</i>
                ตาราง
              </material-button>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-lg-3 mt-2">
                <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                <VueDatePicker v-model="start_date" :format="format" auto-apply :teleport="true"
                  :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                  :clearable="false" fluid :text-input="textInputOptions" />
              </div>

              <div class="col-lg-3 mt-2">
                <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                <VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true"
                  :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                  :clearable="false" fluid  :text-input="textInputOptions" />
              </div>

              <div class="col-auto mt-2">
                <label class="form-label ms-0 png"></label>
                <material-button id="cardSearch" color="primary" class="mb-3" :disabled="start_date > end_date"
                  @click="loadDataReportApi">
                  <i class="material-icons material-symbols-outlined">search</i>
                  {{ $t("buttons.sear") }}
                </material-button>
              </div>
              <div class="col-auto mt-2">
                <label class="form-label ms-0 png"></label>
                <material-button id="cancSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                  @click="cancelBtn">
                  <i class="material-icons material-symbols-outlined">close</i>
                  {{ $t("buttons.canc") }}
                </material-button>
              </div>
            </div>
            <hr />

            <!-- ───── มุมมองรูปภาพ ───── -->
            <div v-if="viewMode === 'visual' && listsum.length > 0" class="row mt-3">
              <div class="col-12 text-center mb-3">
                <h5 class="mb-0"><b>สัดส่วนมูลค่าของหลุดแยกตามประเภทสินค้า</b></h5>
              </div>

              <!-- การ์ดประเภทสินค้า ฝั่งซ้าย -->
              <div class="col-lg-3 col-md-6 order-2 order-lg-1">
                <div v-for="(row, lIdx) in legendLeft" :key="'lg-l' + lIdx" class="overdue-cat-card">
                  <span class="cat-icon">{{ row.icon }}</span>
                  <div class="cat-info">
                    <div class="cat-name">{{ row.mainCatName }}</div>
                    <div class="cat-value">{{ formatNumberDecimalString(row.pawnValue) }} <small>THB</small></div>
                  </div>
                  <span class="cat-dot" :style="{ backgroundColor: row.color }"></span>
                </div>
              </div>

              <!-- Donut ตรงกลาง -->
              <div class="col-lg-6 order-1 order-lg-2 mb-3">
                <div class="overdue-donut-wrap">
                  <Doughnut :data="overdueDonutData" :options="overdueDonutOptions" :plugins="[ChartDataLabels, overdueOuterLabelPlugin]" />
                  <div class="overdue-donut-center">
                    <b>{{ formatNumberDecimalString(totalPawnValue) }}</b>
                    <span>{{ $t("content.ttoverdueitem") }} (THB)</span>
                  </div>
                </div>
              </div>

              <!-- การ์ดประเภทสินค้า ฝั่งขวา -->
              <div class="col-lg-3 col-md-6 order-3 order-lg-3">
                <div v-for="(row, rIdx) in legendRight" :key="'lg-r' + rIdx" class="overdue-cat-card">
                  <span class="cat-icon">{{ row.icon }}</span>
                  <div class="cat-info">
                    <div class="cat-name">{{ row.mainCatName }}</div>
                    <div class="cat-value">{{ formatNumberDecimalString(row.pawnValue) }} <small>THB</small></div>
                  </div>
                  <span class="cat-dot" :style="{ backgroundColor: row.color }"></span>
                </div>
              </div>

              <!-- สรุปตัวเลขรวม -->
              <div class="col-12 order-4 mt-3">
                <div class="overdue-stat-row">
                  <div class="overdue-stat">
                    {{ $t("content.amitem") }}
                    <b>{{ formatNumberString(totalQuantity) }}</b>
                  </div>
                  <div class="overdue-stat">
                    {{ $t("content.allpawntotal") }}
                    <b>{{ formatNumberDecimalString(totalPawnValueH) }}</b>
                  </div>
                  <div class="overdue-stat warn">
                    % {{ $t("content.status_breaking") }}
                    <b>{{ formatNumberDecimalString(lostPercentRef) }} %</b>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="viewMode === 'visual' && listsum.length === 0" class="row mt-3">
              <p style="text-align: center">No Record Found</p>
            </div>

            <!-- ───── มุมมองตาราง (แบบเดิม) ───── -->
            <div v-show="viewMode === 'table'" class="row mt-3">
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th>#</th>
                      <th>{{ $t("content.types") }}</th>
                      <th>{{ $t("content.amnpawnval") }}</th>
                      <th>{{ $t("content.proportion") }}</th>
                      <th>{{ $t("content.amtype") }}</th>
                      <th>{{ $t("content.amitem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- แถวข้อมูลปกติ -->
                    <tr v-for="(row, index) in listsum" :key="index">
                      <td class="text-sm font-weight-normal border-0">
                        {{ formatNumberString(index + 1) }}
                      </td>
                      <td class="text-sm font-weight-normal border-0">
                        {{ row.mainCatName }}
                      </td>
                      <td class="text-sm font-weight-normal border-0">
                        {{ formatNumberDecimalString(row.pawnValue) }}
                      </td>
                      <td class="text-sm font-weight-normal border-0">
                        {{ formatNumberDecimalString(row.proportion) }} %
                      </td>
                      <td class="text-sm font-weight-normal border-0">
                        {{ formatNumberString(row.amount) }}
                      </td>
                      <td class="text-sm font-weight-normal border-0">
                        {{ formatNumberString(row.quantity) }}
                      </td>
                    </tr>

                    <tr style="height: 20px;"  v-if="listsum.length > 0"><td colspan="6" class="border-0"></td></tr>
                    <tr class="bg-light font-weight-bold"  v-if="listsum.length > 0">
                      <td colspan="2" class="text-sm border-0" style="color:black;font-weight: bold;">{{ $t("content.ttoverdueitem") }}</td>
                      <td class="text-sm border-0">{{ formatNumberDecimalString(totalPawnValue) }}</td>
                      <td class="text-sm border-0">100.00 %</td>
                      <td class="text-sm border-0">{{ formatNumberString(totalAmount) }}</td>
                      <td class="text-sm border-0">{{ formatNumberString(totalQuantity) }}</td>
                    </tr>

                    <tr class="bg-light font-weight-bold" v-if="listsum.length > 0">
                      <td colspan="2" class="text-sm border-0" style="color:black;font-weight: bold;">{{ $t("content.allpawntotal") }}</td>
                      <td colspan="3" class="text-sm border-0" style="color:blue;font-size: 16px;font-weight: bold;">{{ formatNumberDecimalString(totalPawnValueH) }}</td>
                      <td class="text-sm border-0"  style="color:blue;font-size: 16px;font-weight: bold;">{{ formatNumberString(totalQuantityH) }}</td>
                    </tr>

                    <tr class="bg-light font-weight-bold" v-if="listsum.length > 0">
                      <td colspan="2" class="text-sm border-0" style="color:black;font-weight: bold;">% {{ $t("content.status_breaking") }}</td>
                      <td colspan="4" class="text-sm border-0">{{ formatNumberDecimalString(lostPercentRef) }} %</td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup>
/* eslint-disable no-unused-vars */
import { reactive, inject, computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import MaterialButton from "@/components/MaterialButton.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'
import { Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(ArcElement, Tooltip, Legend);
ChartJS.defaults.font.family = '"THSarabunNew", "Sukhumvit Set", "Prompt", "Tahoma", "Roboto", sans-serif';
ChartJS.defaults.font.size = 14;

import { useBreakingStore } from '@/stores/breaking';
import { useShopCatOrderStore } from '@/stores/shopcatorder'
import { useCategoryStore } from '@/stores/category'
import { useWorkCaseStore } from '@/stores/workcase'



const storecat = useCategoryStore()
const storeshcat = useShopCatOrderStore()
const storebreak = useBreakingStore()
const storew = useWorkCaseStore()

const { t } = useI18n();
const swal = inject("$swal");
const listsum = ref([]);
const listcat_all = ref([]);
const listcat_order = ref([]);
const listcat_ordernew = ref([]);
const listcat = ref([]);
const start_date = ref(new Date());
const end_date = ref(new Date());

const totalAmount = ref(0);
const totalQuantity = ref(0);
const totalPawnValue = ref(0);

const totalQuantityH = ref(0);
const totalPawnValueH = ref(0);

const lostPercentRef = ref(0);


const key = JSON.parse(localStorage.getItem("shop_seleted"));

// ───── สลับมุมมอง รูปภาพ / ตาราง ─────
const viewMode = ref(localStorage.getItem('overdueViewMode') || 'visual');

function setViewMode(mode) {
  viewMode.value = mode
  localStorage.setItem('overdueViewMode', mode)
}

// สี/ไอคอนประจำประเภทสินค้า (จับคู่จากชื่อหมวด, มี fallback สำหรับหมวดอื่นๆ)
const catStyles = [
  { match: ['ทอง'], color: '#f6c453', icon: '🟨' },
  { match: ['พระ'], color: '#6d8ce8', icon: '📿' },
  { match: ['นาค'], color: '#c08457', icon: '🥉' },
  { match: ['เงิน'], color: '#9ca3af', icon: '🥈' },
  { match: ['พลอย'], color: '#a78bfa', icon: '💠' },
  { match: ['เพชร'], color: '#82d9a5', icon: '💎' },
  { match: ['นาฬิกา'], color: '#5ec8c8', icon: '⌚' },
  { match: ['เบ็ดเตล็ด'], color: '#7dd3fc', icon: '🧺' },
  { match: ['แบรนด์เนม', 'เครื่องประดับ'], color: '#f9a8d4', icon: '👜' },
  { match: ['อื่น'], color: '#cbd5e1', icon: '📦' },
]
const catFallbackColors = ['#f6c453', '#82d9a5', '#5ec8c8', '#a78bfa', '#6d8ce8', '#7dd3fc', '#f9a8d4', '#fda4af', '#cbd5e1', '#fdba74']

function catStyle(name, idx) {
  const found = catStyles.find((s) => s.match.some((m) => (name || '').includes(m)))
  return found || { color: catFallbackColors[idx % catFallbackColors.length], icon: '🏷️' }
}

const donutRows = computed(() =>
  listsum.value.map((row, idx) => {
    const style = catStyle(row.mainCatName, idx)
    return { ...row, color: style.color, icon: style.icon }
  })
)

// การ์ด legend แบ่งครึ่ง ซ้าย-ขวา ของ donut
const legendLeft = computed(() => donutRows.value.slice(0, Math.ceil(donutRows.value.length / 2)))
const legendRight = computed(() => donutRows.value.slice(Math.ceil(donutRows.value.length / 2)))

// donut เฉพาะหมวดที่มีมูลค่า > 0
const donutSlices = computed(() => donutRows.value.filter((r) => Number(r.pawnValue) > 0))

const overdueDonutData = computed(() => ({
  labels: donutSlices.value.map((r) => r.mainCatName),
  datasets: [{
    data: donutSlices.value.map((r) => Number(r.pawnValue)),
    backgroundColor: donutSlices.value.map((r) => r.color),
    borderColor: '#ffffff',
    borderWidth: 2,
    cutout: '58%',
  }],
}))

const overdueDonutOptions = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: { top: 70, bottom: 70, left: 155, right: 155 },
  },
  plugins: {
    legend: { display: false },
    tooltip: {
      callbacks: {
        label: (c) => {
          const total = c.dataset.data.reduce((a, b) => a + b, 0)
          const pct = total > 0 ? ((c.parsed * 100) / total).toFixed(1) : 0
          return ` ${c.label}: ${formatNumberDecimalString(c.parsed)} THB (${pct}%)`
        },
      },
    },
    datalabels: {
      display(context) {
        const total = context.dataset.data.reduce((a, b) => a + b, 0);
        if (!total) return false;
        return (context.dataset.data[context.dataIndex] / total) * 100 >= 5;
      },
      formatter(value, context) {
        const total = context.dataset.data.reduce((a, b) => a + b, 0);
        return `${((value / total) * 100).toFixed(1)}%`;
      },
      color: '#344767',
      font: {
        family: '"THSarabunNew", "Sukhumvit Set", "Prompt", "Tahoma", "Roboto", sans-serif',
        weight: 'bold',
        size: 13,
      },
      textAlign: 'center',
    },
  },
}

const overdueOuterLabelPlugin = {
  id: 'overdueOuterLabel',
  afterDraw(chart) {
    const { ctx, data } = chart;
    if (!data.datasets[0]) return;
    const meta = chart.getDatasetMeta(0);
    if (!meta || meta.data.length === 0) return;
    const total = data.datasets[0].data.reduce((a, b) => a + b, 0);
    if (total === 0) return;

    const FONT = '"THSarabunNew", "Sukhumvit Set", "Prompt", "Tahoma", "Roboto", sans-serif';
    const LH = 17;
    const ITEM_H = LH + 6;
    const EDGE = 8;

    const items = [];
    meta.data.forEach((arc, i) => {
      if (arc.hidden) return;
      const val = data.datasets[0].data[i];
      if (!val) return;
      const midAngle = arc.startAngle + (arc.endAngle - arc.startAngle) / 2;
      const outerR = arc.outerRadius;
      items.push({
        arc, midAngle, outerR,
        color: data.datasets[0].backgroundColor[i],
        pct: ((val * 100) / total).toFixed(1),
        label: (data.labels || [])[i] || '',
        isRight: Math.cos(midAngle) >= 0,
        naturalY: arc.y + Math.sin(midAngle) * (outerR + 22),
      });
    });

    // Only label segments >= 5%; smaller ones show only a dot (legend handles detail)
    const THRESHOLD = 1.5;
    const rightGroup = items.filter(it => it.isRight  && parseFloat(it.pct) >= THRESHOLD).sort((a, b) => a.naturalY - b.naturalY);
    const leftGroup  = items.filter(it => !it.isRight && parseFloat(it.pct) >= THRESHOLD).sort((a, b) => a.naturalY - b.naturalY);

    function spread(group) {
      if (!group.length) return;
      if (group.length === 1) {
        group[0].labelY = Math.max(EDGE + ITEM_H / 2,
          Math.min(chart.height - EDGE - ITEM_H / 2, group[0].naturalY));
        return;
      }
      group.forEach(it => { it.labelY = it.naturalY; });
      for (let k = 1; k < group.length; k++) {
        const minY = group[k - 1].labelY + ITEM_H + 4;
        if (group[k].labelY < minY) group[k].labelY = minY;
      }
      const overflow = (group[group.length - 1].labelY + ITEM_H / 2) - (chart.height - EDGE);
      if (overflow > 0) {
        group.forEach(it => { it.labelY -= overflow; });
        for (let k = 1; k < group.length; k++) {
          const minY = group[k - 1].labelY + ITEM_H + 4;
          if (group[k].labelY < minY) group[k].labelY = minY;
        }
      }
      const topOverflow = (EDGE + ITEM_H / 2) - group[0].labelY;
      if (topOverflow > 0) group.forEach(it => { it.labelY += topOverflow; });
    }

    spread(rightGroup);
    spread(leftGroup);

    ctx.save();

    // Dot on arc edge for every segment
    items.forEach(it => {
      const { arc, midAngle, outerR, color } = it;
      const sx = arc.x + Math.cos(midAngle) * outerR;
      const sy = arc.y + Math.sin(midAngle) * outerR;
      ctx.beginPath();
      ctx.arc(sx, sy, 2.5, 0, Math.PI * 2);
      ctx.fillStyle = color;
      ctx.fill();
    });

    // Connector line + label (name only) for segments >= threshold
    [...rightGroup, ...leftGroup].forEach(it => {
      const { arc, midAngle, outerR, color, label, isRight, labelY } = it;
      const sx = arc.x + Math.cos(midAngle) * outerR;
      const sy = arc.y + Math.sin(midAngle) * outerR;

      ctx.font = `500 13px ${FONT}`;
      const maxW = ctx.measureText(label).width;

      let hEndX;
      if (isRight) {
        hEndX = Math.min(arc.x + outerR + 44, chart.width - EDGE - maxW - 6);
      } else {
        hEndX = Math.max(arc.x - outerR - 44, EDGE + maxW + 6);
      }

      ctx.beginPath();
      ctx.moveTo(sx, sy);
      ctx.lineTo(hEndX, labelY);
      ctx.strokeStyle = color;
      ctx.lineWidth = 1.2;
      ctx.stroke();

      const textX = isRight ? hEndX + 5 : hEndX - 5;
      ctx.textAlign    = isRight ? 'left' : 'right';
      ctx.textBaseline = 'middle';

      ctx.font = `500 13px ${FONT}`;
      ctx.fillStyle = '#344767';
      ctx.fillText(label, textX, labelY);
    });
    ctx.restore();
  },
};


const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

const textInputOptions = {
  format: 'dd/MM/yyyy'
};

const loadDataAllCatApi = async () => {
  // await new Promise((res) => setTimeout(res, 500));
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  // const response = await store.dispatch("categorylistPrintFetch", payload);
  const response = await storecat.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listcat_all.value = response.data.data;
        await loadDataOrderCatApi()
      }
    }
  }
}

const loadDataOrderCatApi = async () => {
  listcat_ordernew.value = []
  listcat_order.value = []
  let data = "";
  let list = []
  data = {
    index: 0,
    size: '100',
    shopUid: key.uid
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storeshcat.shopCatOrderListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
          list = response.data.data.list;
          listcat.value = list
          
      }
    }
  }
}


loadDataAllCatApi()


const loadDataReportApi = async () => {
  totalAmount.value = 0
  totalQuantity.value = 0
  totalPawnValue.value = 0
  lostPercentRef.value = 0
  listsum.value = []
  let data = "";

  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDT23:59:59')
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storebreak.summaryBreakingFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        if (response.data.data.list.length > 0) { 
          let list = response.data.data.list
          totalAmount.value = response.data.data.ext.totalAmount;
          totalQuantity.value = response.data.data.ext.totalQuantity;
          totalPawnValue.value = response.data.data.ext.totalPawnValue;
          await getHistoryInfo()
          listsum.value = await calculateListSum(list);
          lostPercentRef.value = totalPawnValueH.value > 0 
          ? (totalPawnValue.value / totalPawnValueH.value) * 100 
          : 0;
        }  
      }
    }
  }
}


async function getHistoryInfo() {
  totalQuantityH.value = 0
  totalPawnValueH.value = 0
  let list = []
  let data = "";
  data = {
    index: 0,
    size: 1,
    cusUid: '',
    groupUid: key.groupUid,
    refNumber: '',
    shopUid: key.uid,
    fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDT00:00:00'),
    toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDT23:59:59'),
    type: 'PAWN,INTEREST,INC_PRINCIPLE,DEC_PRINCIPLE',
    serialNumber: '',
    status: 'FINISH,FREEZE',
    txFilter: '',
    migrateRefNumber: '',
    stockNumber: '',
    active: 'NONE',
    idCardVerify: 'NONE',
    otp: 'NONE',
    shopRepresent:'NONE',
    outage: 'NONE',
    postpone: 'NONE',
  };
  const payload = data;
  // console.log('wcs p : ' + JSON.stringify(payload));
  const response = await storew.workCaseHistoryFetch(payload);
  // console.log('wcs r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        list = response.data.data.list
        totalQuantityH.value = response.data.data.ext.quantity;
        totalPawnValueH.value = response.data.data.ext.pawnValue;
      }
    }
  }
}


// สมมติว่าคำนวณไว้ใน computed หรือ watcher
const calculateListSum  = async (list) => {
  const masterData = listcat_all.value;
  const orders = listcat.value[0]?.catOrders || {};
  const list1 = list || []; 

  // 1.หายอดรวมทั้งหมดเพื่อคิด %
  const totalValue = list1.reduce((sum, item) => sum + (item.pawnValue || 0), 0);

  // 2. เรียงลำดับตาม catOrders (1, 2, 3...)
  const sortedUids = Object.keys(orders)
    .sort((a, b) => parseInt(a) - parseInt(b))
    .map(key => orders[key]);

  // 3. สร้างข้อมูลสำหรับแต่ละแถวในตาราง
  return sortedUids.map(uid => {
    const master = masterData.find(m => m.uid === uid);
    const record = list1.find(item => 
      item.mainCatCode?.toString().trim() === master?.code?.toString().trim()
    );

    const pawnValue = record ? record.pawnValue : 0;
    // คำนวณ % (สัดส่วน)
    const proportion = totalValue > 0 ? (pawnValue / totalValue) * 100 : 0;

    return {
      mainCatName: master?.name || '',
      pawnValue: pawnValue,
      proportion: proportion, // เก็บเป็นตัวเลขเพื่อไป format ต่อ
      amount: record ? record.amount : 0,
      quantity: record ? record.quantity : 0
    };
  });
};


function cancelBtn() { 
  start_date.value = new Date();
  end_date.value = new Date();
  listsum.value = []
  totalAmount.value = 0
  totalQuantity.value = 0
  totalPawnValue.value = 0
  lostPercentRef.value = 0
  totalQuantityH.value = 0
  totalPawnValueH.value = 0
}

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}


function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}



</script>
  
<style lang="scss" scoped>
/* ───── มุมมองรูปภาพ : การ์ดประเภทสินค้า ───── */
.overdue-cat-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid #eef0f4;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 10px 14px;
  margin-bottom: 10px;

  .cat-icon {
    font-size: 26px;
    line-height: 1;
    flex-shrink: 0;
  }

  .cat-info {
    min-width: 0;
  }

  .cat-name {
    font-size: 13px;
    font-weight: 600;
    color: #67748e;
  }

  .cat-value {
    font-size: 14.5px;
    font-weight: 700;
    color: #344767;

    small {
      font-size: 10px;
      font-weight: 600;
      color: #8a93ab;
    }
  }

  .cat-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-left: auto;
    flex-shrink: 0;
  }
}

/* ───── Donut + ตัวเลขรวมตรงกลาง ───── */
.overdue-donut-wrap {
  position: relative;
  height: 560px;
}

.overdue-donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  pointer-events: none;

  b {
    font-size: 26px;
    color: #344767;
  }

  span {
    font-size: 12px;
    font-weight: 600;
    color: #67748e;
    max-width: 180px;
  }
}

/* ───── แถบสรุปตัวเลขรวม ───── */
.overdue-stat-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}

.overdue-stat {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 10px 22px;
  font-size: 12.5px;
  font-weight: 600;
  color: #67748e;
  text-align: center;

  b {
    display: block;
    font-size: 17px;
    color: #344767;
  }

  &.warn b {
    color: #dc2626;
  }
}
</style>